<header class="new_sign_nav" id="navbar">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light main-nav bg-li ght  mx-0 px-0">
      <a class="navbar-brand" [routerLink]="['/admin']"><img loading="lazy" src="../../../../assets/images/logo.png"></a>
    </nav>


  </div>
</header>


<!-- Modal -->
<!-- <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <form [formGroup]="callLog"  action="">

      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Call Log</h5>
            
          <button type="button"  class="close close_modal" (click)="submitdata(callLog)" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="container">
          <table class="table table-bordered table-sm"   >
            <thead>
              <tr>
                <th scope="">Date/Time</th>
                <th scope="">Phone Number</th>
                <th scope="">Sub Admin</th>
                <th scope="">Remark</th>
                <th scope="">$</th>
                <th scope="">..</th>
              </tr>
            </thead>
            <tbody>
            
              <tr>
                <td>

                </td>

                <td>
                  <input  type="tel" formControlName="phone" class="form-control" maxlength="10"
                    placeholder="Enter Phone Number ">
                </td>

                <td>
                  <select class="form-control" formControlName="subAdminId" >
                    <option *ngFor="let data of subAdminData" value="{{data.id}}" [selected]>{{data.userName}}</option>
                  </select>
                </td>

                <td>
                  <div class="call_logs">
                    <select class="form-control" formControlName="remark1">
                      <option *ngFor="let data of remarkData?.remark" [selected]="data.id === ngSelect" value="{{data.id}}" >{{data.name}}</option>
                    </select>
                  </div>
                  <div class="call_logs">
                    <select class="form-control" formControlName="remark2"  >
                      <option *ngFor="let data of remarkData?.remark2" value="{{data.id}}" >{{data.name}}</option>
                    </select>
                  </div>
                </td>

                <td>
                  <input type="tel" formControlName="price"  class="form-control col-4 ">
                </td>

                <td>
                  <span class="dot"></span>
                </td>
              </tr>

            </tbody>  
           
            <p class="list_main"> <b> Listing</b> </p> 
            
            <tbody  >
              <tr *ngFor="let remarksdata of callLogData">
                <td>
                  {{remarksdata.createdAt* 1000|date:'dd-MM-yyyy'}}

                </td>
                <td>
                  <input  type="tel" value="{{remarksdata.phone}}" disabled  class="form-control" maxlength="10" >
                </td>

                <td>
                  <select class="form-control">
                    <option  value="">{{remarksdata.userName}}</option>
                  </select>
                </td>

                <td>
                  <div class="call_logs">
                    <select class="form-control" >
                      <option > {{remarksdata.remark1}}</option>
                    </select>
                  </div>
                  <div class="call_logs">
                    <select class="form-control"   >
                      <option > {{remarksdata.remark2}}</option>
                    </select>
                  </div>
                </td>

                <td>
                  <input type="tel" value="${{remarksdata.price}}" disabled class="form-control col-4 ">
                </td>

                <td>
                  <span class="dot1"></span>
                </td>
              </tr>

            </tbody>  
          </table>
        </div>
      </div>
    </form>
  </div>
</div> -->

<ng-template #call_logs_modal let-modal>
  <!-- Modal content-->
  <form [formGroup]="callLog"  action="">
  <div class="modal-content">
    <button type="button" class="close close_modal" style="outline: none;" (click)="modal.dismiss('Cross click')"
      data-dismiss="modal"><span aria-hidden="true">×</span></button>
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Call Log</h5>
          
        <button type="button"  class="close close_modal" (click)="submitdata()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="container" id="call_logs_tab">
        <table class="table table-bordered table-sm"   >
          <thead>
            <tr>
              <th scope="">Date/Time</th>
              <th scope="">Phone Number</th>
              <th scope="">Sub Admin</th>
              <th scope="">Remark</th>
              <th scope="">$ & Info</th>
              <th scope="">Time Close</th>
              <th scope="">..</th>
            </tr>
          </thead>
          <tbody>
          
            <tr>
              <td>

              </td>

              <td>
                <input  type="text" formControlName="phone" class="form-control call_logs" placeholder="Enter Phone Number ">
                  <ng-container *ngIf="submitted && callLogsValidator.phone.errors">
                    <p class="error-message" *ngIf=" callLogsValidator.phone.errors.required">
                      Phone Number is required!
                    </p>
                  </ng-container>
              </td>

              <td>
                <select class="form-control call_logs" formControlName="subAdminId" [(ngModel)]="adminId">
                  <!-- <option value="">Select Admin</option> -->
                  <option *ngFor="let data of subAdminData" value="{{data.id}}">{{data.userName}}</option>
                </select>
                <ng-container *ngIf="submitted && callLogsValidator.subAdminId.errors">
                  <p class="error-message" *ngIf=" callLogsValidator.subAdminId.errors.required">
                    Admin is required!
                  </p>
                </ng-container>
              </td>

              <td>
                <div class="call_logs_rem">
                  <select class="form-control" formControlName="remark1">
                    <!-- <option value="">Select</option> -->
                    <option *ngFor="let data of remarkData?.remark" value="{{data.id}}">{{data.name}}</option>
                  </select>
                </div>
                <div class="call_logs_rem">
                  <select class="form-control" formControlName="remark2"  >
                    <!-- <option value="">Select</option> -->
                    <option *ngFor="let data of remarkData?.remark2" value="{{data.id}}">{{data.name}}</option>
                  </select>
                </div>
              </td>

              <td>
                <input type="tel" formControlName="price"  class="form-control col-4 call_logs p_info">
              </td>

              <td>
                
              </td>

              <td>
                <span class="dot"></span>
              </td>
            </tr>

          </tbody>  
         
          <p class="list_main" *ngIf="callLogDataLength != 0"> <b> Listing</b> </p> 
          
          <tbody  >
            <tr *ngFor="let remarksdata of callLogData">
              <td>
                {{(remarksdata.created)* 1000|date:'dd-MM-yyyy h:mm a'}}

              </td>
              <td>
                <input  type="tel" value="{{remarksdata.phone}}" disabled  class="form-control" maxlength="10" >
              </td>

              <td>
                <select class="form-control call_logs">
                  <option  value="">{{remarksdata.userName}}</option>
                </select>
              </td>

              <td>
                <div class="call_logs_rem">
                  <select class="form-control" >
                    <option > {{remarksdata.remark1}}</option>
                  </select>
                </div>
                <div class="call_logs_rem">
                  <select class="form-control"   >
                    <option > {{remarksdata.remark2}}</option>
                  </select>
                </div>
              </td>

              <td>
                <input type="tel" value="${{remarksdata.price}}" disabled class="form-control col-4 p_info">
              </td>
              
              <td>
                <span *ngIf="remarksdata.isCallClosing == 2">{{(remarksdata.closingTime)* 1000|date:'dd-MM-yyyy h:mm a'}}</span>
              </td>

              <td>
                <span class="dot" *ngIf="remarksdata.isCallClosing == 0"></span>
                <span class="dot2" *ngIf="remarksdata.isCallClosing == 1"></span>
                <span class="dot1" *ngIf="remarksdata.isCallClosing == 2"></span>
              </td>
            </tr>

          </tbody>  
        </table>
      </div>
  </div>
  </form>
</ng-template>

<ng-template #announcement_modal let-modal>
  <div id="announcement_modal" class="login_me" role="dialog">
        <div class="modal-content">
          <button type="button" style="outline: none;" (click)="modal.dismiss('Cross click')" class="close close_modal" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span> </button>
          <div class="modal-header">
            <h4 class="modal-title"> Announcements</h4>
          </div>
          <div class="modal-body">
             <div class="col-md-12">
              <div class="ann_texts">

                <textarea class="form-control" placeholder="Announcement 1" [(ngModel)]="announcement1" (keyup)="setAnn1($event)"></textarea>

              </div>
              <div class="ann_texts">

                <textarea class="form-control" placeholder="Announcement 2" [(ngModel)]="announcement2" (keyup)="setAnn2($event)"></textarea>

              </div>
              <div class="ann_texts">

                <textarea class="form-control" placeholder="Announcement 3" [(ngModel)]="announcement3" (keyup)="setAnn3($event)"></textarea>

              </div>

              <div class="col-md-12 text-center">
                <a class="save_btn" (click)="save_announcements()"> Save </a>
                <a class="save_btn" (click)="modal.dismiss('Cross click')"> Cancel </a>
              </div>

             </div>

          </div>
        </div>
    </div>
</ng-template>